window.popup=function(){
    $(".mask").height($(document).height());
    $(".mask,.popup_video").show();
    $(".popup_video_content").html("<video width=\"1280\" height=\"750\" controls autoplay preload loop><source src=\"img/lw2_zzq.mp4\" type=\"video/mp4\"></video>")
};
window.popupClose=function(){
    $(".mask,.popup_video").hide();
    $(".popup_video_content").html("")
};